import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = request.clone({
      setHeaders: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'Content-Type': 'application/json',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'X-CSRFToken': this.getCookie('csrftoken'),
        withCredentials: 'true',
      },
    });

    return next.handle(request);
  }

  getCookie(name): string {
    const cookies = document.cookie.split('; ').map(c => c.split('='));
    const cookie = cookies.find(c => c[0] === name);

    return cookie ? cookie[1] : '';
  }
}
